import { render, staticRenderFns } from "./NavItem.vue?vue&type=template&id=b5f5bf4c&scoped=true&"
import script from "./NavItem.vue?vue&type=script&lang=js&"
export * from "./NavItem.vue?vue&type=script&lang=js&"
import style0 from "./NavItem.vue?vue&type=style&index=0&id=b5f5bf4c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../voicecasting.sk/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5f5bf4c",
  null
  
)

export default component.exports